import axios from 'axios'
import Router from '../router'
const dataURL = process.env.VUE_APP_DATA_URL
const loginURL = process.env.VUE_APP_LOGIN_URL
const sttToolURL =process.env.VUE_APP_STT_TOOL_URL

// const UC1dataURL = "https://aicc-chatbot-backend.mybluemix.net/aicc/back-end/chatbot/v1.0";
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

const instance = axios.create({
  // headers:
  withCredentials: true,     // 允许携带cookie
})
const instance2 = axios.create({
  // headers:
})
let isLoggingIn = false;
// http response 响应拦截器
instance.interceptors.request.use(config => {

  config.headers['token'] = sessionStorage.getItem("token");
  config.headers['user_id'] = sessionStorage.getItem("user_id");
  config.headers['app_link'] = sessionStorage.getItem("app_link");
  config.headers['login_id'] = sessionStorage.getItem("login_id");
  // console.log('config', config)
  return config;
}, error => {
  console.log('err', error)
});

// 🚨 统一处理 401
function handle401() {
  // ✅ 如果已经在登录，直接挂起请求
  if (isLoggingIn) {
    return new Promise(() => {}); // 阻止继续执行（关键）
  }

  // ✅ 只允许触发一次登录
  isLoggingIn = true;

  console.log("🚨 Trigger login only once");

  // 清理 sessionStorage (per-tab isolation)
  sessionStorage.clear();
  // 👉 稍微延迟一下（可选，避免瞬间抖动）
  setTimeout(() => {
    window.location = loginURL;
  }, 300);

  // 挂起当前请求
  return new Promise(() => {});
}

// http response 响应拦截器
instance.interceptors.response.use(response => {
  switch (response.data.code) {
    // 返回401，清除token信息并跳转到登录页面
    case 403:
      Router.push('/forbidden');
      break;
    case 401:
      return handle401();
    default:
      return response;
  }

}, error => {
  if (error.response) {
    // switch (error.response.code) {
    switch (error.response.status) {
      // 返回401，清除token信息并跳转到登录页面
      case 403:
        Router.push('/forbidden');
        break;
      case 401:
        return handle401();
      default:

    }
    // 返回接口返回的错误信息
    return Promise.reject(error.response.data);
  }
});

export default {
  getAllInnerChatUserList() {
    return instance.get(`${dataURL}/innerChat/userList`);
  },
  
  getLogos() {
    return instance.get(`${dataURL}/api/logos`);
  },

  getSttToken(mode) {
    return instance.get(`${dataURL}/api/speech-to-text/token?mode=${mode}`);
  },
  getPersonalConfig() {
    return instance.get(`${dataURL}/getPersonalConfig`);
  },
  getSysConfig() {
    return instance.get(`${dataURL}/showImmediately`);
  },
  getSystemConfig() {
    return instance.get(`${dataURL}/getSystemConfig`);
  },
  getCollections() {
    return instance.get(`${dataURL}/collection`);
  },
  getResultsByDiscovery(params) {
    return instance.post(`${dataURL}/keyword`, params);
  },
  getWebCrawlResultsByDiscovery(params) {
    return instance.post(`${dataURL}/disWebCrawl`, params);
  },
  createIssue(params) {
    return instance.post(`${dataURL}/issue/create`, params);
  },
  updateChatbotIssueIdForManualChat(params){
    return instance.put(`${dataURL}/manual/chatbot/issue`, params);
  },
  updateHis(params) {
    return instance.put(`${dataURL}/redmine/his`, params);
  },
  updateHighLightHis(params) {
    return instance.put(`${dataURL}/redmine/highlight/his`, params);
  },
  updateEscalation(params) {
    return instance.put(`${dataURL}/redmine/escalation`, params);
  },
  updateIssueStatus(params){
    return instance.put(`${dataURL}/redmine/status`, params);
  },
  discoveryEvaluate(params) {
    return instance.post(`${dataURL}/evaluate`, params);
  },
  getSingleMode() {
    return instance.get(`${dataURL}/getSingleMode`);
  },
  markdoc(params) {
    return instance.post(`${dataURL}/doc/mark`, params);
  },
  updatePersonalConfig(params) {
    return instance.post(`${dataURL}/updatePersonalConfig`, params);
  },
  updatePersonalSetting(params) {
    return instance.post(`${dataURL}/updatePersonalSetting`, params);
  },
  getKeywordByDialog(params) {
    return instance.post(`${dataURL}/getKeywordByDialog`, params);
  },
  getKeywordByDialogRight(params){
    return instance.post(`${dataURL}/getKeywordByDialogRight`, params);
  },
  updateKeywordCategroy(params) {
    return instance.post(`${dataURL}/updateKeywordCategroy`, params);
  },
  updateSubjectByIssueId(params) {
    return instance.put(`${dataURL}/updateSubjectByIssueId`, params);
  },
  sttStop(params) {
    return instance.post(`${dataURL}/stt/stop`, params);
  },
  logout() {
    return instance.get(`${loginURL}/logout`);
  },
  updateSttNotesEdit(params) {
    return instance.put(`${dataURL}/redmine/modify/his`, params);
  },

  getHtmlConst(params) {
    return instance.get(`${dataURL}/html/const`);
  },
  updateStandMicIssueId(params) {
    return instance.post(`${dataURL}/issue/standMic`, params);
  },
  // router.post('/updateKeywordRate',updateKeywordRate);
  updateKeywordRate(params) {
    return instance.post(`${dataURL}/updateKeywordRate`, params);
  },

  //router.get('/changeOnCallFlag',changeOnCallFlag);
  changeOnCallFlag() {
    return instance.get(`${dataURL}/changeOnCallFlag`);
  },
  piAnalyze(params) {
    return instance.post(`${dataURL}/piAnalyze`, params);
  },
  getPiIssues(params) {
    return instance.post(`${dataURL}/pi/issues`, params);
  },

  getPiCallInfo(params) {
    return instance.get(`${dataURL}/pi/call/info?sipNum=${params.sipNum}&modeName=${params.modeName}&currentTime=${params.currentTime}`);
  },

  testCallInfo() {
    return instance.get(`${dataURL}/pi/test`);
  },
  getPiCustomerInfo(params) {
    return instance.post(`${dataURL}/pi/customer/info`, params);
  },
  getAllCustomerName() {
    return instance.get(`${dataURL}/pi/customer/name`);
  },
  getAllUsers() {
    return instance.get(`${dataURL}/common/users`);
  },
  getUserCallRecordForPi(params) {
    return instance.post(`${dataURL}/pi/record/info`, params);
  },
  getOnCallInfo(telNum) {
    return instance.get(`${dataURL}/getOnCallInfo?telNum=${telNum}`)
  },


  //manual chat
  getCurrentManualChatStatus(params) {
    return instance.get(`${dataURL}/chat/presence/info?operatorId=${params.operatorId}&modeName=${params.modeName}&currentTime=${params.currentTime}`);
  },

  //manual chat create issue

  createIssueForManualChat(params) {
    return instance.post(`${dataURL}/issue/createIssueForManualChat`, params);
  },

  //close chat
  closeManualChat(params) {
    return instance.get(`${dataURL}/chat/end?userId=${params.userId}&operatorId=${params.operatorId}&type=${params.type}&issueId=${params.issueId}`);
  },

  //manual chat change message status

  changeManualChatMessageStatus(params) {
    // https://xxx/chat/user/status/info ?userId=userId&operatorId=xxx&status=xxx
    // let url = `${dataURL}/chat/user/status/info?userId=${params.userId}&operatorId=${params.operatorId}&status=${params.status}`
    // console.log("url", url);
    return instance.get(`${dataURL}/chat/user/status/info?userId=${params.userId}&operatorId=${params.operatorId}&status=${params.status}`);
  },

  //manual chat send message
  manualChatSendMessage(params) {
    let url = `${dataURL}/chat/message/info?userId=${params.userId}&operatorId=${params.operatorId}&message=${params.message}`;
    console.log(url);
    return instance.get(`${dataURL}/chat/message/info?userId=${params.userId}&operatorId=${params.operatorId}&message=${params.message}`);
  },
  manualChatSendHoldOnMessage(params) {
    let url = `${dataURL}/chat/message/info?userId=${params.userId}&operatorId=${params.operatorId}&message=${params.message}&type=${params.type}`;
    console.log(url);
    return instance.get(`${dataURL}/chat/message/info?userId=${params.userId}&operatorId=${params.operatorId}&message=${params.message}&type=${params.type}`);
  },

  svTalkApi(params){
    let url = `${dataURL}/chat/message/info?userId=${params.userId}&customerId=${params.customerId}&message=${params.message}&type=${params.type}&supervisorId=${params.supervisorId}`;
    return instance.get(url);
  },

  //manual chat update issue
  updateIssueForManualChat(params) {
    return instance.put(`${dataURL}/updateIssueForManualChat`, params);
  },

  //manual chat input fetch-suggestions

  manualChatFetchSuggestions() {
    return instance.get(`${dataURL}/manualChatGetAutoComplete`);
  },


  //manualChatMessageRecord
  manualChatMessageRecord(params) {
    return instance.put(`${dataURL}/message/record`, params);
  },

  //manual get record and others
  getIssuesInfoForManualChatPiProcss(params) {
    // return instance.post(`${dataURL}/manual/pi/issues`, params);
    // pi/issues/info
    return instance.post(`${dataURL}/pi/issues/info`, params);
  },
  getUC1IssueAllText(params) {
    return instance.post(`${dataURL}/getUC1IssueAllText`,params)
  },

  getChatbotIssueByChatIssueId(params){
    return instance.post(`${dataURL}/getChatbotIssueByChatIssueId`,params)
  },
  getCurrentUserCount(){
    return instance.get(`${dataURL}/pi/user/count`);
  },
  changePiStatus(params){
    return instance.get(`${dataURL}/chat/status/change?userId=${params.userId}&status=${params.status}`);
  },
  getEmpathyMatchingToken(){
    return instance.get(`${dataURL}/empathy/token`);
  },

  // router.post('/empathy/info', getEmpathyMatchingInfo);
  getEmpathyMatchingInfo(params){
    return instance.post(`${dataURL}/empathy/info`,params)
  },

  disRequestListSaveInfo(params){
    return instance.post(`${dataURL}/dis/req/info`,params)
  },
  // router.post('/setting/image', settingUploadImage);
  settingUploadImage(params){
    return instance.post(`${dataURL}/setting/image`,params,{ "Content-Type": "multipart/form-data" })
  },

  getCustomerInfoByNum(params){
    return instance.get(`${dataURL}/customer/info/num?phonenum=${params.phonenum}`);
  },

  svHelpRequest_phone_f2f(params){
    return instance.get(`${dataURL}/requestSvHelp?modeName=${params.modeName}&operatorId=${params.operatorId}`);
  },
  svHelpRequest_chat(params){
    return instance.get(`${dataURL}/requestSvHelp?modeName=${params.modeName}&operatorId=${params.operatorId}&customerId=${params.customerId}`);
  },
  getQuestionerAgeAndSexForChat(params){
    return instance.post(`${dataURL}/questioner/chat/info`,params);
  },
  updateQuestionerAgeAndSexForPhone(params){
    return instance.post(`${dataURL}/questioner/call/info`,params);
  },

  searchByCondition(params){
    return instance.post(`${dataURL}/search/list`,params);
  },

  addNewUser(params){
    return instance.post(`${dataURL}/search/user`,params);
  },
  changeCustomerInfoConfirm(params){
    return instance.post(`${dataURL}/search/user/confirm`,params);
  },
  // router.post('/search/user',addNewUser);
  callSttTool(params){
    return instance2.post(`${sttToolURL}/handle-stt-result`,params);
  },
  searchUnsolvedIssues(params) {
    return instance.post(`${dataURL}/search/unsolvedIssues`, params);
  },
  changeIssuePresence(params) {
    return instance.post(`${dataURL}/chat/presence/update`, params);
  },
  getUserInfoByType(params,type){
    if(type == 'internal'){
      return instance.get(`${dataURL}/internal/user/tel?phonenum=${params.phonenum}`);
    }else{
      return instance.get(`${dataURL}/customer/info/num?phonenum=${params.phonenum}`);
    }
  },
  callAnswered(params){
    return instance.post(`${dataURL}/call/answered`,params);
  },
  callEnd(params){
    return instance.post(`${dataURL}/call/end`,params);
  },
  getPbxUserStatus(){
    return instance.get(`${dataURL}/op/getPbxUserStatus`)
  },
  gptChat(params) {
    return instance.post(`${dataURL}/gpt/gptChat`, params);
  },
  generateAcwNextAction(params) {
    return instance.post(`${dataURL}/gpt/acw-next-action`, params);
  },
  openAiSearch(params) {
    return instance.post(`${dataURL}/gpt/openAiSearch`, params);
  },
  searchMonitoringTelNum(params) {
    return instance.get(`${dataURL}/dashboard/search-monitoring-tel-num?telNum=${params.telNum}`);
  },
  stopMonitoring(params) {
    return instance.get(`${dataURL}/dashboard/stop-monitoring?userId=${params.userId}&telNum=${params.telNum}`);
  },
  getImage(params){
    return instance.get(`${dataURL}/image?url=${params}`) ;
  },
  uploadChatImage(params) {
    return instance.post(`${dataURL}/uploadChatImage`, params, {headers: { 'content-type': 'multipart/form-data' }});
  },
  removeChatImage(params) {
    return instance.delete(`${dataURL}/removeChatImage`, {params});
  },
  getCustomerInfoByPage(params){
    let url = `${dataURL}/customer/info/?page=${params.page}&pageSize=${params.pageSize}`
    if(params.keyword){
      url = `${url}&keyword=${params.keyword}`
    }
    return instance.get(url);
  },
  
}

